
import ROUTES from '@utils/routes';
const IS_PRODUCTION = process.env.NODE_ENV === 'production';

export const STRINGS = {
    campaign: "The Strange and Unusual",
    campaignPack: "12 Round Pack",
    campaignBox: "Skullz Mega Pack",

    homePage: {
        headline: "Welcome to a guided tour through a fascinating collection of weird and thought provoking artifacts from The Strange and Unusual Oddity Parlor",
        subtext: <>
            <a href="https://www.thestrangeandunusual.com" target="_blank" rel='noreferrer noopener'>
                {"Master Curator Josh Balz "}
            </a>
            {"presents a first of its kind set of digital collectible NFTs (non-fungible tokens), with hand crafted descriptions and special audio commentary from Doug Bradley, acclaimed actor, most notable for portraying \"Pinhead\" from the cult classic Hellraiser."}            </>,
        variantsTitle: 'Exhibit A',
        variants: 'Lars Kommienezuspadt’s signature photography style lays the foundation for a unique set of 40 cards presented across six captivating varieties. Visitors who purchase a pack will also be dealt a pair of Tarot cards to be used in a Tarot Reading on the Exhibit’s website to earn additional collectibles.'
    },

    resourcesPage: {
        resourcesTitle: 'Available Resources',
        cpuAvailable: "CPU Available",
        netAvailable: "NET Available",
        ramAvailable: "RAM Available",
        stakeCpu: "Stake CPU",
        amountOfCpuToStake: "Amount of CPU to Stake in Wax",
        net: "NET",
        stakeNet: "Stake Net",
        amountOfNetToStake: "Amount of Net to Stake in Wax",
        ram: "RAM",
        buyRam: "Buy RAM",
        amountOfRamToBuy: "Amount of RAM to Buy in Wax",
        successCPU: 'CPU successfully staked',
        successNET: 'NET successfully staked',
        successRAM: 'RAM successfully purchased',
        availableFunds: 'Your available balance is'
    },

    probabilities: [
        {
            template_id: IS_PRODUCTION ? '298325' : '218325',
            packContent: '25 Cards',
            title: "Packs Probabilities",
            probabilities:
            [
                { rarity: 'Photo Tier (Oddity)', probability: '40%' },
                { rarity: 'Photo Tier (Entropy)', probability: '32%' },
                { rarity: 'Photo Tier (Memento Mori)', probability: '13%' },
                { rarity: 'Animation Tier (Pepper’s Ghost)', probability: '8%' },
                { rarity: 'Animation Tier (Twitch)', probability: '8%' },
                { rarity: 'Illustration Tier (Tarot)', note: 'Guaranteed Tarot Pair - Additional Roll', probability: '100%' },
                { rarity: 'Video/Audio Tier (Narration)', note: 'Additional Roll', probability: '42.71%' },
                { rarity: 'Illustration Tier (Clinical)', note: 'Additional Roll', probability: '.17%' },
                { rarity: 'Redemption Tier (Merchandise)', note: 'Additional Roll and Crafted', probability: '.17%' },
                { rarity: 'Photo Tier (X-Ray) ', note: 'Crafted' }
            ]
        }
    ],

    craftPage: {
        craftCard: 'Ask a question, open a pack, and interpret your situation and solution',
        confirmationTitle: 'Are you sure you want to craft?',
        confirmationDescription: "All selected items will be burned. This cannot be undone.",
        description: <>
            <ol>
                <li>
                    Every pack of The Strange and Unusual Exhibit A comes with a 2 card cross Tarot Reading.
                </li>
                <li>
                    Interpret your Tarot cards by combining them together along with empty Pack Wrappers to manifest X-Ray cards.
                </li>
                <li>
                    There is a Tarot Reading recipe for every combination of Tarot cards possible in packs.
                </li>
                <li>
                    Visit the Exhibit often and you will be able to create all 4 X-Ray cards.
                </li>
                <li>
                    Dedicated collectors can combine their X-Rays cards together with large amounts of empty Pack Wrappers, purchasable on secondary markets, to unlock a T-Shirt redemption NFT. T Shirts can also be found in packs.
                </li>
            </ol>
        </>
    },

    craftBuyPacks: 'Buy Packs',
    craftButton: 'Get Reading',
    selectMintNumbers: 'Select Mint Numbers',

    packsOnly: "Packs Only",
    cardsOnly: "Cards Only",
    allAssets: "All Assets",
    redeemable: "Redeemable",
    noAssetsFound: "No Assets Found",
    variantFilter: 'Variant Filter',
    rarityFilter: 'Rarity Filter',
    cardIdFilter: 'Card Id Filter',

    howToBuyHeadline: 'How to Buy The Strange and Unusual NFTs',
    rarities: "Rarities",

    home: "Home",
    packRips: "Pack Rips",
    inventory: "Inventory",
    leaderboard: "Leaderboard",
    faq: "FAQ",
    news: "News",
    craft: "Tarot",
    resources: "Resources",
    fiatPurchases: "Fiat Purchases",

    totalPacksMessage: "{0} Ember Packs in total",
    totalPointsMessage: "{0} Points earned in total",

    logIn: "Log In",
    logOut: "Log Out",
    notFound: "Not Found",
    loading: "Loading",
    loadingEl: "Loading...",
    confirm: "Confirm",
    cancel: "Cancel",
    close: "Close",
    error: "Error",
    defaultErrorMessage: "An error has occurred!",

    goToHome: "Home Page",

    day: "day",
    days: "days",
    hour: "hour",
    hours: "hours",
    minute: "minute",
    minutes: "minutes",
    second: "second",
    seconds: "seconds",

    available: "available",
    notSupportedCreaditCards: "No Discover Card",
    reservedPacks: "Packs are reserved during the checkout process",

    shop: "Shop",
    buyPack: "Buy Pack",
    buyBox: "Buy VIP Pass",
    buyPacks: "Buy Packs",
    buyBoxes: "Buy VIP Passes",
    buyAPack: "Buy a Pack",
    buyABox: "Buy a VIP Pass",
    buyMorePacks: "Buy more Packs",
    singlePack: "Pack",
    packsAmount: "Packs amount:",
    boxesAmount: "VIP Passes amount:",
    fan: "Fans",
    athlete: "Athletes",
    featureCTA: "Join Waitlist",
    releaseCTA: "Notify Me",
    upcomingTitle: "The Strange and Unusual",
    upcomingSubtext: 'An all new NFT collection straight from the heart of The Strange and Unusual Oddities Parlor. This one-of-a-kind curio collection showcases the extraordinary and the bizarre: from long forgotten personal effects to unusual curiosities. ',
    shopPageSoon: "Shop available soon",

    soldOut: "Sold Out",
    secondaryMarketTitle: "Couldn't buy a pack here? Try the secondary market:",

    openPack: "Open Asset",
    openPacks: "Open",
    openAndBurn: "Open and Burn",
    openPackConfirmation: "Are you sure you want to open {0} with mint {1}?",
    openPackSuccess: "Pack successfully opened!",

    goToPackRips: "Go To Pack Rips",
    noRips: "You don't have any opened pack yet.",
    viewRip: "View Rips",
    viewAsset: "View Asset",
    burn: "Burn",
    burnConfirmationTitle: "Are you sure you want to burn the asset {0} with mint #{1}?",
    openAndBurnConfirmationTitle: "Are you sure you want to open and burn the asset {0} with mint #{1}?",
    burnConfirmationWarning: "Warning: burning assets is an irreversible action.",
    viewCollection: "You can also view your NFT collection on AtomicHub, NFTHIVE and WAX Stash",
    viewEntireCollection: "View the entire Strange and Unusual collection",
    recentItem: "New",

    wax: "WAX",

    buyPacksFor: "Buy {0} packs for {1}",
    buyPackConfirmation: "Are you sure you want to buy one {0} for {1}?",
    buyPacksConfirmation: "Are you sure you want to buy {0} {1}s for a total of {2}?",
    packPurchaseLimit: "You can purchase up to {0} packs per time.",

    successfulBuy: "Congratulations!",
    buySuccessMessage: "Your purchase has been successful. Check out your inventory.",

    assetNotMintedDisclaimer: "Mint number is being calculated...",
    packProbabilities: "{0} Probabilities",

    faqItems: [
        {
            question: "How and When Can I Purchase a Pack?",
            answer:
            <>
                <p>
                    The Exhibit opens on Friday, October 8th at 10AM PST / 5PM UTC via <a href={`/#${ROUTES.buypacks}`}>The Strange and Unusual Cards shop page</a>. Visitors to the Exhibit must have a valid credit card (no Discover available), or WAX to purchase.
                </p>
                <p>
                    In order to purchase a pack right at 10AM collectors need to be waiting in the Shop page of the website. The website will automatically refresh at 10AM PST / 5 PM UTC to allow you to complete your purchase. Please disable any ad blockers and be aware that using a credit card may require you to input an additional code or 2FA. Purchases need to be authorized using an ‘authorize payment’ button which will appear during the checkout process. There is no need to refresh your browser and your packs are reserved during the checkout process.
                </p>
                <p>
                    After you purchase your packs, you will be taken to the Inventory page where you can view your NFT (non-fungible token) collectibles. Clicking on the assets will enlarge them and allow all the dark details to shine through.
                </p>
            </>
        },
        {
            question: "What Can I Do With These NFTs?",
            answer:
            <>
                <p>
                Any NFT you collect from The Strange and Unusual collection is yours to own forever. NFTs can be traded on markets such as the <a href="http://atomichub.io" target="_blank" rel='noreferrer noopener'>AtomicHub</a>, viewed on the Inventory page as well as apps such as <a href="http://tokenhead.io" target="_blank" rel='noreferrer noopener'>TokenHead</a>, and used in the Tarot Card reading feature of the website. NFTs are digital assets and any third party can decide to integrate The Strange and Unusual NFTs into their product, allowing them to be used in games, to earn tokens, or for display in <a href="http://immersys.io" target="_blank" rel='noreferrer noopener'>metaverse worlds</a>.
                </p>
            </>
        },
        {
            question: "What Can I Do With The Tarot Cards?",
            answer:
            <>
                <p>
                After opening a pack, collectors are rewarded with a random selection of Tarot cards. By visiting the Tarot Reading page on the website you can combine these Tarot cards to create new NFTs only available through the Tarot Reading feature. Discover your past, present, and future while being rewarded with some of the rarest collectibles in the set. The Tarot Reading feature is ever expanding and new recipes could appear at any time, or not - the future is not foretold.
                </p>
            </>
        },
        {
            question: "What is WAX?",
            answer:
            <>
                <a href='https://wax.io' target='_blank' rel='noreferrer noopener'>WAX</a> is a blockchain designed for collectibles like The Strange and Unusual Exhibit A release. They describe their mission as bringing NFTs to the mass market in the “safest, most secure, environmentally friendly, and easy-to-use marketplace in the world.” WAX does not use nearly the amount of electricity to operate and does not cost the user fees to conduct transactions, which is common on other top chains. By collecting NFTs on WAX, you support an environmentally safe solution to collecting digitally scarce goods.
            </>
        },
        {
            question: "Who is FACINGS?",
            answer:
            <>
                <p>
                    <a href="http://facings.io" target="_blank" rel='noreferrer noopener'>FACINGS</a> is a publisher of high quality NFT projects. They specialize in launching innovative and unique collections using state of the art technology. FACINGS’ tech is engineered from the ground up to improve the expected user experience on WAX and gives collectors a fun and safe way to collect the digital NFTs they want.
                </p>
                <p>
                FACINGS has teamed up with The Strange and Unusual to provide a custom built pack opening and crafting experience that is unmatched on WAX today. It is designed to reduce the frustrations and defects that users dealt with in other past campaigns.
                </p>
            </>
        },
        {
            question: "Are NFTs Bad For The Environment?",
            answer:
            <>
                <p>
                While all NFTs do use electricity to be produced, the amount that is consumed on the WAX blockchain is 125,000 times less than Ethereum. In fact, WAX is <a href="https://on.wax.io/co2/" target="_blank" rel='noreferrer noopener'>carbon neutral</a>. WAX NFTs have offset almost 4 million tons of carbon emissions by not being minted on the Ethereum blockchain. As technology improves, WAX will continue to use less energy and find ways to use renewable sources for the energy it does consume.
                </p>
            </>
        },
        {
            question: "What Else Should I Know?",
            answer:
            <>
                <p>
                    <b>Promo NFT</b>: Sign up for more information <a href="http://cards.thestrangeandunusual.com" target="_blank" rel='noreferrer noopener'>on the website</a> and you will be eligible to claim a Free NFT before launch. There will be a time based drop for the NFT on AtomicHub limited to only those who signed up on the website before the drop time. We will announce the cutoff for signups and the time and location of the drop soon.
                </p>
                <p>
                    <b>Wax Cloud Wallet</b>: Wax Cloud Wallet (“WCW”) is an easy to use way to store and manage your NFTs on the WAX blockchain. When users sign up or sign in to WAX Cloud Wallet, a WAX blockchain account is automatically created associated with your email address. Secure your wallet with 2FA for the most user friendly and safe custodial wallet in blockchain.
                </p>
            </>
        },
        {
            question: "How do I trade my WAX packs or cards to someone else?",
            answer:
            <>
                <p>
                You can transfer your WAX packs and cards to someone else by visiting your WAX Cloud Wallet NFT inventory and clicking on the transfer icon on the top of the NFT. Then enter the wallet name of the community member that you wish to trade with and click Send.
                </p>

            </>
        },
        {
            question: "What are NFTs?",
            answer:
            <>
                <p>
                NFT stands for Non Fungible Token and is a way of creating unique digital collectible assets. Refer to this article for more information on NFTs.
                </p>

            </>
        },
        {
            question: "How do I know my NFTs are authentic?",
            answer:
            <>
                <p>
                    {`Always refer to the verified checkmark on the collection to ensure your NFTs are created by The Strange and Unusual under the "oddityparlor" author account.`}
                </p>

            </>
        },
        {
            question: "How can I get support?",
            answer: <><p>Please email <a href='mailto:hello@facings.io'>hello@facings.io</a> for support.</p></>
        }
    ],

    howToBuy: {
        createWaxWallet: 'Create a WAX Cloud Wallet (WCW)',
        waxWalletDescription: 'The WAX Cloud Wallet is a lightweight and easy-to-use wallet account that you can use directly in your browser to hold and view your WAX NFTs. Instead of having to manage private keys, you can create a wallet with as little information as an email and password, or use any number of social accounts like Facebook and Twitter!',
        waxWalletButton: 'Create WAX Cloud Wallet',
        waxWalletLogin: 'Login Using Your New WCW',
        waxWalletLoginDescription: 'Use the "Log In" button in the top right or the button below to initialize your WAX Cloud Wallet on the The Strange and Unusual NFT website. A popup will appear and asking you to input your WCW information and authorize the login.',
        waxWalletLoginButton: "You're already logged in",
        packs: 'Purchase Your Packs',
        packsDescription: 'Go to the "Shop" page, select the number of packs you would like to purchase, then click "Buy Packs" Follow the onscreen prompts to fill out your credit or debt card information. Once you complete your purchase, it may take a few minutes for your packs to appear in your WCW.',
        openPacks: 'Open Packs and View NFTs',
        openPacksDescription: 'Use the navbar to open packs and view your NFTs! You can also trade your NFTs on secondary markets like AtomicHub!',
        openPacksButton: 'View Inventory'
    },

    redemption: 'Redemption',

    redeemAsset: "Redeem Asset",
    validateAddress: "Please validate your Address",
    fullName: "Full Name",
    email: "E-mail",
    addressLine1: "Address Line 1",
    addressLine2: "Address Line 2",
    addressLine3: "Address Line 3",
    addressLine4: "Address Line 4",
    city: "City",
    state: "State / Province / Region",
    country: "Country",
    zipCode: "ZIP Code / Postal Code",
    accountName: "ETH Wallet",

    customerFields: {
        accountName: "account_name",
        items: "items",
        email: "email"
    },

    addressFields: {
        fullName: "fullname",
        addressLine1: "line1",
        addressLine2: "line2",
        addressLine3: "line3",
        addressLine4: "line4",
        city: "city",
        state: "state",
        country: "country",
        zipCode: "zipcode",
        accountName: "account_name"
    },

    US: "United States of America",

    countriesList: [{ "name": "Afghanistan" }, { "name": "Åland Islands" }, { "name": "Albania" }, { "name": "Algeria" }, { "name": "American Samoa" }, { "name": "Andorra" }, { "name": "Angola" }, { "name": "Anguilla" }, { "name": "Antarctica" }, { "name": "Antigua and Barbuda" }, { "name": "Argentina" }, { "name": "Armenia" }, { "name": "Aruba" }, { "name": "Australia" }, { "name": "Austria" }, { "name": "Azerbaijan" }, { "name": "Bahamas" }, { "name": "Bahrain" }, { "name": "Bangladesh" }, { "name": "Barbados" }, { "name": "Belarus" }, { "name": "Belgium" }, { "name": "Belize" }, { "name": "Benin" }, { "name": "Bermuda" }, { "name": "Bhutan" }, { "name": "Bolivia (Plurinational State of)" }, { "name": "Bonaire, Sint Eustatius and Saba" }, { "name": "Bosnia and Herzegovina" }, { "name": "Botswana" }, { "name": "Bouvet Island" }, { "name": "Brazil" }, { "name": "British Indian Ocean Territory" }, { "name": "United States Minor Outlying Islands" }, { "name": "Virgin Islands (British)" }, { "name": "Virgin Islands (U.S.)" }, { "name": "Brunei Darussalam" }, { "name": "Bulgaria" }, { "name": "Burkina Faso" }, { "name": "Burundi" }, { "name": "Cambodia" }, { "name": "Cameroon" }, { "name": "Canada" }, { "name": "Cabo Verde" }, { "name": "Cayman Islands" }, { "name": "Central African Republic" }, { "name": "Chad" }, { "name": "Chile" }, { "name": "China" }, { "name": "Christmas Island" }, { "name": "Cocos (Keeling) Islands" }, { "name": "Colombia" }, { "name": "Comoros" }, { "name": "Congo" }, { "name": "Congo (Democratic Republic of the)" }, { "name": "Cook Islands" }, { "name": "Costa Rica" }, { "name": "Croatia" }, { "name": "Cuba" }, { "name": "Curaçao" }, { "name": "Cyprus" }, { "name": "Czech Republic" }, { "name": "Denmark" }, { "name": "Djibouti" }, { "name": "Dominica" }, { "name": "Dominican Republic" }, { "name": "Ecuador" }, { "name": "Egypt" }, { "name": "El Salvador" }, { "name": "Equatorial Guinea" }, { "name": "Eritrea" }, { "name": "Estonia" }, { "name": "Ethiopia" }, { "name": "Falkland Islands (Malvinas)" }, { "name": "Faroe Islands" }, { "name": "Fiji" }, { "name": "Finland" }, { "name": "France" }, { "name": "French Guiana" }, { "name": "French Polynesia" }, { "name": "French Southern Territories" }, { "name": "Gabon" }, { "name": "Gambia" }, { "name": "Georgia" }, { "name": "Germany" }, { "name": "Ghana" }, { "name": "Gibraltar" }, { "name": "Greece" }, { "name": "Greenland" }, { "name": "Grenada" }, { "name": "Guadeloupe" }, { "name": "Guam" }, { "name": "Guatemala" }, { "name": "Guernsey" }, { "name": "Guinea" }, { "name": "Guinea-Bissau" }, { "name": "Guyana" }, { "name": "Haiti" }, { "name": "Heard Island and McDonald Islands" }, { "name": "Holy See" }, { "name": "Honduras" }, { "name": "Hong Kong" }, { "name": "Hungary" }, { "name": "Iceland" }, { "name": "India" }, { "name": "Indonesia" }, { "name": "Côte d'Ivoire" }, { "name": "Iran (Islamic Republic of)" }, { "name": "Iraq" }, { "name": "Ireland" }, { "name": "Isle of Man" }, { "name": "Israel" }, { "name": "Italy" }, { "name": "Jamaica" }, { "name": "Japan" }, { "name": "Jersey" }, { "name": "Jordan" }, { "name": "Kazakhstan" }, { "name": "Kenya" }, { "name": "Kiribati" }, { "name": "Kuwait" }, { "name": "Kyrgyzstan" }, { "name": "Lao People's Democratic Republic" }, { "name": "Latvia" }, { "name": "Lebanon" }, { "name": "Lesotho" }, { "name": "Liberia" }, { "name": "Libya" }, { "name": "Liechtenstein" }, { "name": "Lithuania" }, { "name": "Luxembourg" }, { "name": "Macao" }, { "name": "Macedonia (the former Yugoslav Republic of)" }, { "name": "Madagascar" }, { "name": "Malawi" }, { "name": "Malaysia" }, { "name": "Maldives" }, { "name": "Mali" }, { "name": "Malta" }, { "name": "Marshall Islands" }, { "name": "Martinique" }, { "name": "Mauritania" }, { "name": "Mauritius" }, { "name": "Mayotte" }, { "name": "Mexico" }, { "name": "Micronesia (Federated States of)" }, { "name": "Moldova (Republic of)" }, { "name": "Monaco" }, { "name": "Mongolia" }, { "name": "Montenegro" }, { "name": "Montserrat" }, { "name": "Morocco" }, { "name": "Mozambique" }, { "name": "Myanmar" }, { "name": "Namibia" }, { "name": "Nauru" }, { "name": "Nepal" }, { "name": "Netherlands" }, { "name": "New Caledonia" }, { "name": "New Zealand" }, { "name": "Nicaragua" }, { "name": "Niger" }, { "name": "Nigeria" }, { "name": "Niue" }, { "name": "Norfolk Island" }, { "name": "Korea (Democratic People's Republic of)" }, { "name": "Northern Mariana Islands" }, { "name": "Norway" }, { "name": "Oman" }, { "name": "Pakistan" }, { "name": "Palau" }, { "name": "Palestine, State of" }, { "name": "Panama" }, { "name": "Papua New Guinea" }, { "name": "Paraguay" }, { "name": "Peru" }, { "name": "Philippines" }, { "name": "Pitcairn" }, { "name": "Poland" }, { "name": "Portugal" }, { "name": "Puerto Rico" }, { "name": "Qatar" }, { "name": "Republic of Kosovo" }, { "name": "Réunion" }, { "name": "Romania" }, { "name": "Russian Federation" }, { "name": "Rwanda" }, { "name": "Saint Barthélemy" }, { "name": "Saint Helena, Ascension and Tristan da Cunha" }, { "name": "Saint Kitts and Nevis" }, { "name": "Saint Lucia" }, { "name": "Saint Martin (French part)" }, { "name": "Saint Pierre and Miquelon" }, { "name": "Saint Vincent and the Grenadines" }, { "name": "Samoa" }, { "name": "San Marino" }, { "name": "Sao Tome and Principe" }, { "name": "Saudi Arabia" }, { "name": "Senegal" }, { "name": "Serbia" }, { "name": "Seychelles" }, { "name": "Sierra Leone" }, { "name": "Singapore" }, { "name": "Sint Maarten (Dutch part)" }, { "name": "Slovakia" }, { "name": "Slovenia" }, { "name": "Solomon Islands" }, { "name": "Somalia" }, { "name": "South Africa" }, { "name": "South Georgia and the South Sandwich Islands" }, { "name": "Korea (Republic of)" }, { "name": "South Sudan" }, { "name": "Spain" }, { "name": "Sri Lanka" }, { "name": "Sudan" }, { "name": "Suriname" }, { "name": "Svalbard and Jan Mayen" }, { "name": "Swaziland" }, { "name": "Sweden" }, { "name": "Switzerland" }, { "name": "Syrian Arab Republic" }, { "name": "Taiwan" }, { "name": "Tajikistan" }, { "name": "Tanzania, United Republic of" }, { "name": "Thailand" }, { "name": "Timor-Leste" }, { "name": "Togo" }, { "name": "Tokelau" }, { "name": "Tonga" }, { "name": "Trinidad and Tobago" }, { "name": "Tunisia" }, { "name": "Turkey" }, { "name": "Turkmenistan" }, { "name": "Turks and Caicos Islands" }, { "name": "Tuvalu" }, { "name": "Uganda" }, { "name": "Ukraine" }, { "name": "United Arab Emirates" }, { "name": "United Kingdom of Great Britain and Northern Ireland" }, { "name": "United States of America" }, { "name": "Uruguay" }, { "name": "Uzbekistan" }, { "name": "Vanuatu" }, { "name": "Venezuela (Bolivarian Republic of)" }, { "name": "Viet Nam" }, { "name": "Wallis and Futuna" }, { "name": "Western Sahara" }, { "name": "Yemen" }, { "name": "Zambia" }, { "name": "Zimbabwe" }],

    successfulRedeem: "Congratulations!",
    redeemSuccessMessage: "The redeem request transaction has been sent. We will prepare your package and send you an email when we ship it.",
    redeemErrorMessage: "Your asset couldn't been redeemed, please try again later.",

    poweredByWax: "Powered by WAX",
    facingsLogo: "Built by FACINGS",
    atomicAssets: "Built with Atomic Assets",
    telegramLogo: 'FACINGS telegram group',
    twitterLogo: 'Twitter',
    facebookLogo: 'Facebook',
    waxLink: "https://wax.io",
    facingsLink: "https://facings.io",
    atomicLink: "https://wax.atomichub.io/explorer/collection/darkpinup",
    telegramLink: "https://t.me/facings",

    availableIn: "Available in",
    comingSoon: "Coming Soon",
    releaseDate: "September 29th",
    releaseTime: "10:00 AM PDT | 01:00 PM EDT | 05:00 PM UTC",

    formTitle: "Be the first to know about The Strange and Unusual NFT release!",
    helpFormTitle: "Having Trouble? Our Support Team Can Help!",
    formSuccessMessage: "We'll be sending your exclusive asset.",
    formButtonPreRelease: "Sign Up for Launch Alerts",
    formButtonPostRelease: "Sign Up for Launch Alerts",
    help: "Need Help?",

    privacyPolicy: 'Privacy Policy',
    terms: 'Terms & Conditions',
    license: 'NFT License',

    cpuErrorMessage: <>Stake some CPU <a href={`/#${ROUTES.resources}`} target='_blank' rel='noreferrer noopener'>here</a> to solve the issue</>,
    netErrorMessage: <>Stake some NET <a href={`/#${ROUTES.resources}`} target='_blank' rel='noreferrer noopener'>here</a> to solve the issue</>,
    waxWallet: <>{"Don't have a WAX wallet yet? Create one "}<a href='https://wallet.wax.io' target='_blank' rel='noreferrer noopener'>here</a></>
};

export default STRINGS;
